import { isSSR } from '../helper';
import { useStableEvent } from './useStableEvent/useStableEvent';
const PointerEventsEnabled = isSSR ? false : 'PointerEvent' in window;
const guardedDocument = typeof document === 'undefined' ? null : document;
export const useClickOutside = (elementRef, clickOutSideHandler) => {
    useStableEvent(PointerEventsEnabled ? 'pointerdown' : 'mousedown', guardedDocument, (event) => {
        if (!elementRef.current?.contains(event.target) ||
            elementRef.current?.isEqualNode(event.target)) {
            clickOutSideHandler(event.target || undefined);
        }
    });
};
